import { KAMBI_ROOT_ROUTE } from '@core/Areas/KambiClient/constants'

export const getEventLinkForKambiClient = (eventId: number, isNewSportsUiEnabled: boolean) => {
  return isNewSportsUiEnabled ? `/sports/event/${eventId}` : `/${KAMBI_ROOT_ROUTE}/event/${eventId}`
}
